import {
  IServiceBlock,
  getServiceBlockTiers,
} from '@/models/commercial-proposals/blocks.store';

import EmptyCell from '../../cells/EmptyCell/EmptyCell';
import HeadingCell from '../../cells/HeadingCell/HeadingCell';
import ServiceBaseRow from '../ServiceBaseRow/ServiceBaseRow';

export default function ServiceHeadingRow({ block }: { block: IServiceBlock }) {
  const tiers = getServiceBlockTiers(block.type);

  return (
    <ServiceBaseRow
      style={{ borderBottom: '1px solid var(--mantine-color-gray-2)' }}
    >
      <EmptyCell />
      <HeadingCell block={block} id={'config.heading[0]'} />
      {Array.from({ length: tiers }).map((_, index) => (
        <HeadingCell
          key={index}
          block={block}
          id={`config.heading[${index + 1}]`}
        />
      ))}
    </ServiceBaseRow>
  );
}
